import Page from "@/components/pages/inventory/sales-order/warehouse/page";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import dayjs from "dayjs";
import z from "zod";

const searchSchema = z.object({
  salesOrderId: z.string().optional(),
  type: z.enum(["edit", "view", "add"]).optional(),
  status: z
    .enum(["ALL", "TODAY", "AWAITING_PREPARATION", "PRINTED", "HOLD", "PACKED"])
    .catch("AWAITING_PREPARATION")
    .default("AWAITING_PREPARATION"),
  needRefresh: z.boolean().optional(),
  // set default range to this month
  dateRangeStart: z.string().catch(() => dayjs.tz().startOf("week").toISOString()),
  dateRangeEnd: z.string().catch(() => dayjs.tz().endOf("week").toISOString()),
});

export const Route = createFileRoute(
  "/_app/inventory/sales-order/_modal/warehouse",
)({
  component: Page,
  validateSearch: zodValidator(searchSchema),
});
